import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import MultiStoryRowEntries from './multi_story_row_entries';
import { sendAnalyticsEvent } from '../../../utils/analytics';

export default class MultiStoryRowElements extends Component {
  shouldComponentUpdate = (nextProps) =>
    nextProps.display_name !== this.props.display_name;

  entryClickEventParams = () =>
    this.props.isRecommendedShowsRow
      ? ['Recommended Shows', 'Click', this.props.display_name]
      : ['Aggregation', 'Click', `Card ${this.props.cardID}`];

  handleTitleClick = () => sendAnalyticsEvent(
    ...this.entryClickEventParams()
  );

  handleButtonClick = () => sendAnalyticsEvent(
    'Aggregation',
    'Click',
    `Card ${this.props.cardID}`
  );

  formattedSeeMoreButton = () => (
    <RosettaFormattedMessage parentFilename={__filename}
      id="see_more"
      description='Message displayed on "See More" button for non-video entries'
      defaultMessage="See More"
    />
  );

  formattedWatchNowButton = () => (
    <RosettaFormattedMessage parentFilename={__filename}
      id="watch_now"
      description='Message displayed on "See More" button for video entries'
      defaultMessage="Watch Now"
    />
  );

  seeMoreButton = (path) => (
    <div className="button">
      <Link to={path} onClick={this.handleButtonClick}>
        <button>
          {
            this.props.isRecommendedShowsRow
              ? this.formattedWatchNowButton()
              : this.formattedSeeMoreButton()
          }
        </button>
      </Link>
    </div>
  );

  render() {
    const { display_name, entries: [{ path }] } = this.props;
    return (
      <div className="content">
        <div className="title">
          <Link to={path}
            dangerouslySetInnerHTML={{ __html: display_name }}
            onClick={this.handleTitleClick}
          />
        </div>
        <MultiStoryRowEntries {...this.props} />
        {this.seeMoreButton(path)}
      </div>
    );
  }
}

MultiStoryRowElements.propTypes = {
  cardID: PropTypes.number.isRequired,
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired
    })
  ).isRequired,
  display_name: PropTypes.string.isRequired,
  isRecommendedShowsRow: PropTypes.bool.isRequired
};
